(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const focusKey = sessionStorage.getItem('mojis-cart-focus');
    if (focusKey) {
      sessionStorage.removeItem('mojis-cart-focus');
      setTimeout(() => (focusKey === 'empty' ? root.querySelector('.mojis-cart__shop') : [...root.querySelectorAll('[data-cart-change]')].find(button => button.dataset.key === focusKey && !button.disabled))?.focus(), 0);
    }
    const status = () => root.querySelector('[data-cart-status]');
    let pending = false;
    root.addEventListener('click', async event => {
      const button = event.target.closest('[data-cart-change]');
      if (!button || !root.contains(button) || pending) return;
      const url = root.dataset.changeUrl;
      const cartUrl = root.dataset.cartUrl;
      if (!url?.startsWith('/') || url.startsWith('//') || !cartUrl?.startsWith('/') || cartUrl.startsWith('//')) return;
      pending = true;
      root.querySelectorAll('[data-cart-change]').forEach(node => { node.disabled = true; });
      status().textContent = 'Updating your bag…';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const snapshot = await fetch(cartUrl + '.js', { credentials: 'same-origin', cache:'no-store', signal:controller.signal });
        if (!snapshot.ok) throw new Error('Could not check your bag.');
        const fresh = await snapshot.json();
        const line = fresh.items?.find(item => item.key === button.dataset.key);
        if (!line || line.quantity !== Number(button.dataset.previous)) throw new Error('Your bag changed elsewhere. Refresh it and review before updating.');
        if (!root.isConnected) return;
        const response = await fetch(url, { method:'POST', credentials: 'same-origin', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({ id:line.key, quantity:Number(button.dataset.quantity) }), signal:controller.signal });
        const result = await response.json();
        if (!root.isConnected) return;
        if (!response.ok || result.status || !Array.isArray(result.items) || !Number.isSafeInteger(result.item_count) || !Number.isSafeInteger(result.total_price)) throw new Error(result.description || 'Could not update your bag.');
        const changed = result.items.find(item => String(item.id) === String(line.id) && JSON.stringify(item.properties || {}) === JSON.stringify(line.properties || {}) && String(item.selling_plan_allocation?.selling_plan?.id || '') === String(line.selling_plan_allocation?.selling_plan?.id || ''));
        const desired = Number(button.dataset.quantity);
        if (desired === 0 ? !!changed : changed?.quantity !== desired) throw new Error('The response did not confirm this update. Check your bag before trying again.');
        sessionStorage.setItem('mojis-cart-focus', (changed || result.items[0])?.key || 'empty');
        location.reload();
      } catch (error) {
        status().textContent = (error.name === 'AbortError' || error instanceof TypeError ? 'The update response was interrupted. Check your bag before trying again.' : error.message) + ' Refresh this page to review your bag.';
      } finally { clearTimeout(timeout); pending = false; }
    });
  };
  const start = () => document.querySelectorAll('[data-mojis-cart]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
